import { useEffect, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDownloadPdf } from "../hooks/useDownloadPdf"
import { useOutletContextPlan } from "../hooks/useOutletContextPlan"

export default function PlanDownload() {
  const { token } = useParams()
  const { plan } = useOutletContextPlan()
  const navigate = useNavigate()
  const { downloadPdf } = useDownloadPdf()
  const hasDownloaded = useRef(false)

  useEffect(() => {
    if (token && !hasDownloaded.current) {
      hasDownloaded.current = true
      downloadPdf(token, plan?.name ?? "plan")
        .then(() => {
          navigate(`/plan/${token}/activities`)
        })
        .catch((error) => {
          console.error("Download failed:", error)
          // Still navigate even if download fails
          navigate(`/plan/${token}/activities`)
        })
    }
  }, [token, downloadPdf, navigate, plan?.name])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p className="text-gray-600">Downloading plan...</p>
      </div>
    </div>
  )
}
